import { render, staticRenderFns } from "./userPermissionTypeBackup.vue?vue&type=template&id=1f08cbf6&"
import script from "./userPermissionTypeBackup.vue?vue&type=script&lang=js&"
export * from "./userPermissionTypeBackup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports